import type { CollaborateListView } from "../types/collaborateThread";
import type { Thread } from "../types/collaborateThread";

export const COLLABORATE_THREAD_PAGE_SIZE = 20;

export type ThreadListPage = {
  items: Thread[];
  hasMore: boolean;
  nextCursor: string | null;
  total: number;
};

export type VersionCount = {
  versionNumber: number;
  count: number;
};

export type ThreadFilterSummary = {
  listViewCounts: Record<CollaborateListView, number>;
  versionCounts: VersionCount[];
};

export type ThreadListQuery = {
  listView: CollaborateListView;
  versionFilter: number | null;
  limit?: number;
  cursor?: string | null;
};
